export enum ComparisonType {
  text = 0,
  singleChoice = 1,
  multiChoice = 2,
  numeric = 3,
  instanceCount = 4,
  datetime = 5,
  relativeUser = 6,
  record = 7, // compare based on id of record (e.g. form submission, object model entry)
  accountRelation = 8,
  boolean = 9,
  accountRelationUser = 10,
}